import { SvgProps } from "../Form";

export const UserTrustIcon = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7234_2155)">
      <path
        d="M10.2083 14C8.11767 14 6.41667 12.299 6.41667 10.2083C6.41667 8.11767 8.11767 6.41667 10.2083 6.41667C12.299 6.41667 14 8.11767 14 10.2083C14 12.299 12.299 14 10.2083 14ZM10.2083 7.58333C8.76108 7.58333 7.58333 8.76108 7.58333 10.2083C7.58333 11.6556 8.76108 12.8333 10.2083 12.8333C11.6556 12.8333 12.8333 11.6556 12.8333 10.2083C12.8333 8.76108 11.6556 7.58333 10.2083 7.58333ZM10.7911 11.2898L11.8912 10.2206C12.1222 9.996 12.1275 9.62675 11.9035 9.39575C11.6789 9.16533 11.3097 9.15892 11.0787 9.38408L9.975 10.4562C9.91725 10.5146 9.82217 10.5146 9.76383 10.4562L9.25283 9.95575C9.02242 9.73058 8.65375 9.73467 8.428 9.96508C8.20225 10.1955 8.20633 10.5642 8.43675 10.7899L8.94775 11.2904C9.20267 11.5401 9.53692 11.6643 9.87058 11.6643C10.2042 11.6643 10.5391 11.5389 10.7917 11.2893L10.7911 11.2898ZM5.25 7C3.31975 7 1.75 5.43025 1.75 3.5C1.75 1.56975 3.31975 0 5.25 0C7.18025 0 8.75 1.56975 8.75 3.5C8.75 5.43025 7.18025 7 5.25 7ZM5.25 1.16667C3.96317 1.16667 2.91667 2.21317 2.91667 3.5C2.91667 4.78683 3.96317 5.83333 5.25 5.83333C6.53683 5.83333 7.58333 4.78683 7.58333 3.5C7.58333 2.21317 6.53683 1.16667 5.25 1.16667ZM1.16667 13.4167C1.16667 11.361 2.70258 9.61858 4.739 9.36483C5.05867 9.32517 5.28558 9.0335 5.24592 8.71383C5.20625 8.39417 4.91108 8.17075 4.59492 8.2075C1.97517 8.53358 0 10.7736 0 13.4167C0 13.7392 0.261333 14 0.583333 14C0.905333 14 1.16667 13.7392 1.16667 13.4167Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7234_2155">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
